

/**
 * 毫米与米之间的单位转换工具。
 * 所有物理计算以米为基础单位，用户交互与属性管理界面以毫米为基础单位。
 */

/**
 * 将毫米（mm）转换为场景单位米（m）。
 * 
 * @param {number} mm - 毫米数值
 * @returns {number} 米数值
 */
export function convertMmToM(mm: number): number {
  // 1米 = 1000毫米，因此将毫米数值除以 1000
  return mm / 1000;
}

/**
 * 将场景单位米（m）转换为毫米（mm）。
 * 
 * @param {number} m - 米数值
 * @returns {number} 毫米数值
 */
export function convertMToMm(m: number): number {
  // 将米数值乘以 1000 转换为毫米
  return m * 1000;
}


